import { classNames } from 'primereact/utils'

import { DeliveryForecastProcessCompletions } from '../../features/selfservice/supplier/data'
import { DelForProcessBodyTemplate } from './DelForProcessBodyTemplate'

export const DelForProcessIsActiveBodyTemplate = (
  completion: DeliveryForecastProcessCompletions,
  isActive: boolean,
  size?: number,
) => {
  if (!completion || !isActive) return null

  return (
    <div
      className={classNames({
        'opacity-40	': !isActive,
      })}
    >
      {DelForProcessBodyTemplate(completion, size)}
    </div>
  )
}
